
const useAdminContainerHeight = (

) => {

    // height of the right side menu list
    const tabWrapEL = document.querySelector('#admin-tab-menu-container');
    // return tabWrapEL ? tabWrapEL.clientHeight : 0;
    return tabWrapEL ? Math.max(tabWrapEL.clientHeight, 840) : 840;

}

export default useAdminContainerHeight;